import sanityClient from "@sanity/client";
export default sanityClient({
    projectId: "8i5qce9d",
    dataset: "production",
    token: "skV8Z0IJRQvsE2ugUYEhpO8e2wR9E6f9EPz9zocTXDqS7NslnnvEGgm24Ct2RaRp46snVH8Ie5scQQYtg1ELS8EyHAY4lgIBHs61Y6CddPby72cx8tIg0Gl6elJBoq1fWJPGxBjwzOKzvnj3QIAhKcsVeS23kvy1T9Kym22V2eTYGQSFPOfX"
})